import { createFileRoute } from '@tanstack/react-router'

import { AccountConnectionsPage } from '#features/settings/account/account-connections-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/account/connections',
)({
  head: () => ({
    meta: [
      {
        title: 'Connected accounts',
      },
    ],
  }),
  component: () => <AccountConnectionsPage />,
})
